import { gql } from '@apollo/client';

// Public — no auth. Preview an invite for the landing page.
export const INVITE_PREVIEW = gql`
  query InvitePreview($token: String!) {
    invitePreview(token: $token) {
      valid
      source
      invitedByName
      expiresAt
      profiles {
        id
        name
        thumbnails {
          url
        }
      }
    }
  }
`;

// Public — no auth. Redeem an invite whose recipient phone is known;
// returns a Firebase custom token to sign in with.
export const REDEEM_INVITE_AUTOLOGIN = gql`
  mutation RedeemInviteAutoLogin($token: String!) {
    redeemInviteAutoLogin(token: $token) {
      success
      customToken
      linkedProfileIds
      message
    }
  }
`;

// Authed fallback — link an invite's profiles to the signed-in account.
export const REDEEM_INVITE_FOR_CURRENT_USER = gql`
  mutation RedeemInviteForCurrentUser($token: String!) {
    redeemInviteForCurrentUser(token: $token) {
      success
      linkedProfileIds
      message
    }
  }
`;
